var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('route-tabs',{attrs:{"tabs":_vm.tabs,"tab-prefix":"logs_"}})
}
var staticRenderFns = []

export { render, staticRenderFns }